import { Link, useRouterState } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { Compass } from "@/lib/public-icons";
import { PeopleNotFound } from "@/components/marketing/site/people-not-found";
import { isPeopleHost } from "@/lib/host/host-rewrite";
import { currentHost } from "@/lib/host/request";

// A mistyped address keeps the shell (mounted under `_authenticated`; public ones stand alone).
// On ppl-ai.com `lib/host/host-rewrite.ts` rewrites unknown paths; one that still arrives gets
// that site's page.
export function NotFound() {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const host = currentHost();
  if (host !== undefined && isPeopleHost(host)) return <PeopleNotFound withHead />;
  const inside = !["/login", "/forgot-password", "/reset-password"].some((path) =>
    pathname.startsWith(path),
  );
  return (
    <div className="mx-auto flex max-w-md flex-col items-center gap-3 px-6 py-16 text-center">
      <span className="bg-idle-fill text-idle-ink grid size-10 place-items-center rounded-lg">
        <Compass className="size-5" aria-hidden="true" />
      </span>
      <h1 className="text-2xl font-semibold tracking-tight">Page not found</h1>
      <p className="text-muted-foreground text-sm text-pretty">
        Nothing lives at{" "}
        <span className="text-foreground font-mono text-xs break-all">{pathname}</span>. It may have
        moved, or the address has a typo.
      </p>
      <Button asChild className="mt-1">
        <Link to={inside ? "/" : "/login"}>{inside ? "Back to the dashboard" : "Sign in"}</Link>
      </Button>
    </div>
  );
}
